/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { DataPageOfVisit } from '../models/data-page-of-visit';
import { visitsList } from '../fn/visits/visits-list';
import { VisitsList$Params } from '../fn/visits/visits-list';

@Injectable({ providedIn: 'root' })
export class VisitsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `visitsList()` */
  static readonly VisitsListPath = '/visits/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `visitsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  visitsList$Response(params?: VisitsList$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfVisit>> {
    return visitsList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `visitsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  visitsList(params?: VisitsList$Params, context?: HttpContext): Observable<DataPageOfVisit> {
    return this.visitsList$Response(params, context).pipe(
      map((r: StrictHttpResponse<DataPageOfVisit>): DataPageOfVisit => r.body)
    );
  }

}
